
























































import {Component, Prop, Vue} from 'vue-property-decorator';
import ViewBase from '@/views/ViewBase';
import {BankAccountOperations} from '@/enums/BankAccountOperations';
import BankAccountsApi from '@/apis/BankAccountsApi';
import BankAccountTransactionResponseModel from '@/models/bankaccounts/BankAccountTransactionResponseModel';

@Component({
        name: 'BankAccountTransactions',
    },
)
export default class BankAccountTransactions extends ViewBase {
    @Prop({default: 0, required: true})
    public bankAccountId!: number;

    public transactions: BankAccountTransactionResponseModel[] = [];
    public authorized: boolean = false;
    public search: string = '';

    public headers = [
        {text: 'Detail', align: 'center', sortable: false, value: 'action'},
        {text: 'Date', align: 'left', sortable: true, value: 'transactionDate'},
        {text: 'Fund', align: 'left', sortable: true, value: 'fundName'},
        {text: 'Description', align: 'left', sortable: true, value: 'transactionDescription'},
        {text: 'Debit', align: 'end', sortable: true, value: 'debit'},
        {text: 'Credit', align: 'end', sortable: true, value: 'credit'},
    ];

    public get showTransactions(): boolean {
        if ( !this.initializing && !this.initializationError ) {
            return true;
        }

        return false;
    }

    public async created() {
        if ( this.$store.state.selectedBankAccount.authorizedOperations & BankAccountOperations.VIEW_TRANSACTIONS )
        {
            this.authorized = true;

            try {
                this.resetInitializationValues();

                const api = new BankAccountsApi();
                this.transactions = await api.getTransactionsAsync(this.bankAccountId, this.$store.state.member.jwt);
            }
            catch ( err ) {
                await this.handleInitializationErrorAsync(err);
            }
            finally {
                this.initializing = false;
            }
        }
    }
}

